import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Package, LogOut, FileText } from 'lucide-react';
import { Button } from '../ui/button';
import { ProductsTab } from './ProductsTab';
import { TradeApplicationsTab } from '../TradeApplicationsTab';

export function Dashboard({ creds, onLogout }) {
  const navigate = useNavigate();
  const [tab, setTab] = useState('products');

  return (
    <div className="min-h-screen bg-slate-100">
      <header className="bg-[#01195d] text-white py-4 px-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Package className="w-8 h-8" />
            <div>
              <h1 className="text-xl font-bold">GS Pacific Admin</h1>
              <p className="text-sm text-slate-300">Management Dashboard</p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <button onClick={() => navigate('/')} className="text-sm text-slate-300 hover:text-white">
              View Website
            </button>
            <Button data-testid="admin-logout-button" onClick={onLogout} variant="outline" size="sm" className="border-white/30 text-white hover:bg-white/10">
              <LogOut className="w-4 h-4 mr-2" />Logout
            </Button>
          </div>
        </div>
      </header>

      <div className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex gap-8">
            <button
              data-testid="products-tab-button"
              onClick={() => setTab('products')}
              className={`py-4 border-b-2 font-medium text-sm ${
                tab === 'products'
                  ? 'border-[#01195d] text-[#01195d]'
                  : 'border-transparent text-slate-500 hover:text-slate-700'
              }`}
            >
              <Package className="w-4 h-4 inline mr-2" />Products
            </button>
            <button
              data-testid="applications-tab-button"
              onClick={() => setTab('applications')}
              className={`py-4 border-b-2 font-medium text-sm ${
                tab === 'applications'
                  ? 'border-[#01195d] text-[#01195d]'
                  : 'border-transparent text-slate-500 hover:text-slate-700'
              }`}
            >
              <FileText className="w-4 h-4 inline mr-2" />Trade Applications
            </button>
          </div>
        </div>
      </div>

      <main className="max-w-7xl mx-auto py-8 px-6">
        {tab === 'products' && <ProductsTab creds={creds} />}
        {tab === 'applications' && <TradeApplicationsTab creds={creds} />}
      </main>
    </div>
  );
}

export default Dashboard;
